import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { EntitlementService } from '../../services/entitlement.service';
import { Ship } from '../../Ship';
import { ShipsContact } from '../../data/ShipsContact';
import { ShipService } from '../../services/ship.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as customValidator from '../../validators/ship-validator';
import { Address } from '../../data/Address';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-ship-register',
  templateUrl: './ship-register.component.html',
  styleUrls: ['./ship-register.component.css']
})
export class ShipRegisterComponent implements OnInit {
  @Output() registerCancel = new EventEmitter();
  newShipForm: UntypedFormGroup;
  newShip: Ship;
  shipsContact: ShipsContact;
  save_ba_btn_spinner: string;
  showRegister = true;
  showMerchants = false;
  cincCodes: String[] = [];
  tycomCodes: String[] = [];
  marineDssnCodes: String[] = [];
  shipClasses: String[] = [];
  existingLocations: String[] = [];
  existingDSSNs: String[] = [];
  defaultCountry: any;

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.initForm();
    this.newShip = new Ship();
    this.shipService.getShipContactBlank().subscribe(
      (data: ShipsContact) => (this.shipsContact = data),
      (error) => console.log('Error calling Ship Contact Blank: ' + error)
    );
    this.shipService.getShipLookupCodes('CINC').subscribe(
      (resp) => {
        this.cincCodes = resp;
      },
      () => {
        console.log('Error retrieving codes for lookup: CINC');
      }
    );
    this.shipService.getShipLookupCodes('TYCOM').subscribe(
      (resp) => {
        this.tycomCodes = resp;
      },
      () => {
        console.log('Error retrieving codes for lookup: TYCOM');
      }
    );
    this.shipService.getShipLookupCodes('SHIP_CLASS').subscribe(
      (resp) => {
        this.shipClasses = resp;
      },
      () => {
        console.log('Error retrieving codes for lookup: SHIP_CLASS');
      }
    );
    this.shipService.getShipLookupCodes('MARINE_DSSN').subscribe(
      (resp) => {
        this.marineDssnCodes = resp;
      },
      () => {
        console.log('Error retrieving codes for lookup: MARINE_DSSN');
      }
    );
    this.shipService.getShipProfiles().subscribe(
      (ships: Ship[]) => {
        ships.forEach((ship) => {
          this.existingLocations.push(ship.shipLocation);
          if (ship.dssn && !this.existingDSSNs.includes(ship.dssn)) {
            this.existingDSSNs.push(ship.dssn);
          }
        });
      }
    );
  }

  initForm() {
    // @ts-ignore
    this.newShipForm = new UntypedFormGroup({
      ship: new UntypedFormGroup({
        location: new UntypedFormControl(null, [
          Validators.required,
          customValidator.shipLocationValidator
        ]),
        name: new UntypedFormControl(null, [
          Validators.required,
          customValidator.shipNameValidator
          ]),
        hull: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z0-9]*')
        ]),
        shipClass: new UntypedFormControl('', Validators.required),
        crewSize: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[0-9]*')
        ])
      }),
      fleet: new UntypedFormGroup({
        port: new UntypedFormControl(null, [
          Validators.required,
          customValidator.roundTripHomeportValidator,
          Validators.maxLength(100)
        ]),
        dssn: new UntypedFormControl('', [Validators.pattern('[0-9]{1,10}'), Validators.required]),
        marineDssn: new UntypedFormControl(''),
        tycom: new UntypedFormControl('', Validators.required),
        cinc: new UntypedFormControl('', Validators.required)
      }),
      disbo: new UntypedFormGroup({
        officer: new UntypedFormControl(null, [customValidator.disboNameValidator]),
        phone: new UntypedFormControl(null, customValidator.phoneValidator),
        email: new UntypedFormControl(null, Validators.email)
      }),
      lsr: new UntypedFormGroup({
        contact: new UntypedFormControl(null, customValidator.lsrContactValidator),
        phone: new UntypedFormControl(null, customValidator.phoneValidator)
      }),
      shipaddr: new UntypedFormGroup({
        address1: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z0-9 /-]*')
        ]),
        address2: new UntypedFormControl(null, Validators.pattern('[a-zA-Z0-9 /-]*')),
        address3: new UntypedFormControl(null, Validators.pattern('[a-zA-Z0-9 /-]*')),
        city: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z /-]*')
        ]),
        state: new UntypedFormControl(null, Validators.required),
        zip: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[0-9/-]{5,10}')
        ])
      }),
      bulk: new UntypedFormGroup({
        contactName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
        company: new UntypedFormControl('', [Validators.maxLength(30)]),
        address1: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z0-9 /-]*')
        ]),
        address2: new UntypedFormControl(null, Validators.pattern('[a-zA-Z0-9 /-]*')),
        address3: new UntypedFormControl(null, Validators.pattern('[a-zA-Z0-9 /-]*')),
        city: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[a-zA-Z /-]*')
        ]),
        state: new UntypedFormControl(null, Validators.required),
        zip: new UntypedFormControl(null, [
          Validators.required,
          Validators.pattern('[0-9/-]{5,10}')
        ]),
        country: new UntypedFormControl('', [Validators.required])
      })
    });
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  onCancel() {
    this.newShipForm.reset();
    this.registerCancel.emit();
  }

  register() {
      if(this.newShipForm.invalid) {
        Object.keys(this.newShipForm.controls).forEach(key => {
          if(this.newShipForm.get(key).invalid) {
            console.log(this.newShipForm.get(key));
            this.newShipForm.get(key).markAsTouched();

            // @ts-ignore
            Object.keys(this.newShipForm.get(key).controls).forEach(item => {
              if (this.newShipForm.get(key).get(item).invalid) {
                this.newShipForm.get(key).get(item).markAsTouched();
              }
            })
          }
        });
        return;
      }

    const newShipLoc = this.newShipForm.get('ship').get('location').value;
    const newShipDssn = this.newShipForm.get('fleet').get('dssn').value;
    const dupLoc = this.existingLocations.includes(newShipLoc);
    const dupDssn = newShipDssn && this.existingDSSNs.includes(newShipDssn);

    if (dupLoc || dupDssn) {
      let errorString = 'Error registering new ship.<br/>';
      if (dupLoc) {
        errorString += 'Please verify the location is unique.<br/>';
      }
      if (dupDssn) {
        errorString += 'Please verify the DSSN is unique.';
      }

      this.messageService.error(errorString);
    } else {
      this.showRegister = false;
      this.showMerchants = true;
    }
  }

  onSubmit() {
    this.save_ba_btn_spinner = 'fa fa-spinner fa-spin';
  }

  createShipFromForm(): Ship {
    const createdShip = new Ship();
    createdShip.bulkAddress = new Address();
    createdShip.shipAddress = new Address();

    createdShip.shipLocation = this.newShipForm
      .get('ship')
      .get('location').value;
    createdShip.shipName = this.newShipForm.get('ship').get('name').value.toUpperCase();
    createdShip.shipHull = this.newShipForm.get('ship').get('hull').value.toUpperCase();
    createdShip.shipClass = this.newShipForm.get('ship').get('shipClass').value;
    createdShip.crewSize = this.newShipForm.get('ship').get('crewSize').value;

    createdShip.shipPort = this.newShipForm.get('fleet').get('port').value;
    createdShip.dssn = this.newShipForm.get('fleet').get('dssn').value;
    createdShip.marineDssn = this.newShipForm
      .get('fleet')
      .get('marineDssn').value;
    createdShip.shipTycom = this.newShipForm.get('fleet').get('tycom').value;
    createdShip.shipCinc = this.newShipForm.get('fleet').get('cinc').value;

    createdShip.disboName = this.newShipForm.get('disbo').get('officer').value;
    createdShip.disboPhone = this.newShipForm.get('disbo').get('phone').value;
    createdShip.disboEmail = this.newShipForm.get('disbo').get('email').value;

    createdShip.lsrContact = this.newShipForm.get('lsr').get('contact').value;
    createdShip.phoneNumber = this.newShipForm.get('lsr').get('phone').value;

    createdShip.bulkAddress.bulkCompany = this.newShipForm.get('bulk').get('company').value;
    createdShip.bulkAddress.bulkContactName = this.newShipForm.get('bulk').get('contactName').value;

    createdShip.bulkAddress.addressLine1 = this.newShipForm
      .get('bulk')
      .get('address1').value;
    createdShip.bulkAddress.addressLine2 = this.newShipForm
      .get('bulk')
      .get('address2').value;
    createdShip.bulkAddress.addressLine3 = this.newShipForm
      .get('bulk')
      .get('address3').value;
    createdShip.bulkAddress.city = this.newShipForm.get('bulk').get('city').value;
    createdShip.bulkAddress.state = this.newShipForm.get('bulk').get('state').value;
    createdShip.bulkAddress.zip = this.newShipForm.get('bulk').get('zip').value;
    createdShip.bulkAddress.country = this.newShipForm.get('bulk').get('country').value;

    createdShip.shipAddress.addressLine1 = this.newShipForm
    .get('shipaddr')
    .get('address1').value;
  createdShip.shipAddress.addressLine2 = this.newShipForm
    .get('shipaddr')
    .get('address2').value;
  createdShip.shipAddress.addressLine3 = this.newShipForm
    .get('shipaddr')
    .get('address3').value;
  createdShip.shipAddress.city = this.newShipForm.get('shipaddr').get('city').value;
  createdShip.shipAddress.state = this.newShipForm.get('shipaddr').get('state').value;
  createdShip.shipAddress.zip = this.newShipForm.get('shipaddr').get('zip').value;

    createdShip.isDecommissioned = 'N';

    return createdShip;
  }
}
